export const LINK_BG_CLASSNAME = 'sidebar-link-bg';
export const LINK_TEXT_CLASSNAME = 'sidebar-link-text';
